import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPreassignmentPrompt extends Layout {
    buttonCancel: Button;
    buttonOK: Button;
    panelButtons: Panel;
    sourceReasonCode: DataSource;
    textboxComments: Textbox;
    textboxReasonCode: Textbox;
}
